
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Episodes from '../pages/episodes/page';
import EpisodeDetail from '../pages/episodes/[id]/page';
import EpisodeLanding from '../pages/episode-landing/page';
import About from '../pages/about/page';
import Subscribe from '../pages/subscribe/page';
import Contact from '../pages/contact/page';
import Privacy from '../pages/privacy/page';
import Admin from '../pages/admin/page';
import NotFound from '../pages/NotFound';

// Export as default export as expected by router/index.ts
const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/episodes',
    element: <Episodes />,
  },
  {
    path: '/episodes/:id',
    element: <EpisodeDetail />,
  },
  {
    path: '/episode-landing',
    element: <EpisodeLanding />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/subscribe',
    element: <Subscribe />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '/404',
    element: <NotFound />,
  },
  {
    path: '*',
    element: <NotFound />,
  }
];

export default routes;
